<template>
  <div class="sm-add-customer">
    <div class="sm-add-customer-inner">
      <breadcrumbs-block 
        v-if="!isMobile"
        :crumbs="breadcrumbs"
      />
      <form-customer
        :backErrors="formErrors"
        @submit="handleCreateCustomer"
      />
    </div>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Spinner from '@/components/Spinner';
import FormCustomer from '@/components/forms/FormCustomer';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'add-customer',
  components: {
    'breadcrumbs-block': Breadcrumbs,
    'form-customer': FormCustomer,
    'sm-spinner': Spinner
  },
  data() {
    return {
      breadcrumbs: [
        {
          link: 'customers',
          text: 'Customers'
        },
        {
          link: 'add-customer',
          text: 'Add New User',
          current: true
        }
      ],
      formErrors: [],
      showSpinner: false
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    })
  },
  methods: {
    ...mapActions({
      createCustomer: 'customers/createCustomer',
    }),
    handleCreateCustomer(data) {
      this.showSpinner = true;
      this.formErrors = [];

      this.createCustomer(data)
        .then(res => {
          this.$router.push({
            query: {
              tab: 'all',
              new_user: data.user_name
            }
          })
          this.showSpinner = false;
          this.$router.push('customers');
        })
        .catch(e => {
          let err = e.response

          if (err.data && err.data.errors) {
            Object.keys(err.data.errors).forEach(key => {
              this.formErrors.push({
                field: key,
                msg: err.data.errors[key][0]
              });
            });
          }

          this.showSpinner = false;
        })
    },
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/customers/_add-customer.scss';
</style>